import {WCBaseComponent} from './WCBaseComponent.js';

const template = document.createElement('template');

template.innerHTML = `
  <div class="wc-dropdown dropdown ms-auto">
    <button class="wc-dropdown-button btn btn-xs btn-gray-100 shadow-sm" data-bs-toggle="dropdown">
      <i class="wc-dropdown-button-icon bi-three-dots-vertical"></i>
    </button>
    <ul class="wc-dropdown-menu dropdown-menu dropdown-menu-end border-0 shadow">
      <li class="wc-dropdown-menu-item">
        <a href="#!" class="wc-dropdown-menu-item-anchor dropdown-item">
          <i class="wc-dropdown-menu-item-icon bi-cursor text-blue"></i>
          <span class="wc-dropdown-menu-item-caption text-gray-600">Botão</span>
        </a>
      </li>
    </ul>
  </div>
`;

const presets = {
  atualizar: {
    icon: {content: 'bi-arrow-clockwise'},
    caption: {content: 'Atualizar'}
  },
  procurar: {
    icon: {content: 'bi-search'},
    caption: {content: 'Procurar'}
  },
  adicionar: {
    icon: {color: 'text-green', content: 'bi-plus-circle'},
    caption: {content: 'Adicionar'}
  },
  alterar: {
    icon: {content: 'bi-pencil'},
    caption: {content: 'Alterar'}
  },
  excluir: {
    icon: {color: 'text-red', content: 'bi-trash'},
    caption: {content: 'Excluir'}
  },
  ajuda: {
    icon: {content: 'bi-question-circle'},
    caption: {content: 'Ajuda'}
  },
  preferencias: {
    icon: {color: 'text-teal', content: 'bi-sliders'},
    caption: {content: 'Preferências'}
  },
  configuracoes: {
    icon: {content: 'bi-gear'},
    caption: {content: 'Configurações'}
  }
};

export class WCDropdown extends WCBaseComponent {

  constructor () {
    super();
  }

  render () {
    let contentNodes = [...this.childNodes];
    let clone = template.cloneNode(true);
    let wcDropdown = clone.content.querySelector('.wc-dropdown').cloneNode(false);
    let wcButton = clone.content.querySelector('.wc-dropdown-button').cloneNode(false);
    let wcIcon = clone.content.querySelector('.wc-dropdown-button-icon').cloneNode(false);
    let wcMenu = clone.content.querySelector('.wc-dropdown-menu').cloneNode(false);
    wcButton.append(wcIcon);
    wcDropdown.append(wcButton);
    contentNodes.forEach(node => {
      wcMenu.appendChild(node);
    });
    wcDropdown.append(wcMenu);
    this.innerHTML = '';
    this.replaceWith(wcDropdown);
  }

}

export class WCDropdownButton extends WCBaseComponent {

  constructor () {
    super();
  }

  render () {
    let contentNodes = [...this.childNodes];
    let clone = template.cloneNode(true);
    let wcDropdownButton = clone.content.querySelector('.wc-dropdown-button').cloneNode(false);
    contentNodes.forEach(node => {
      wcDropdownButton.appendChild(node);
    });
    this.innerHTML = '';
    this.replaceWith(wcDropdownButton);
  }

}

export class WCDropdownButtonIcon extends WCBaseComponent {

  constructor () {
    super();
  }

  render () {
    // let contentNodes = [...this.childNodes];
    let clone = template.cloneNode(true);
    let wcDropdownButtonIcon = clone.content.querySelector('.wc-dropdown-button-icon').cloneNode(false);
    // contentNodes.forEach(node => {
    //   wcDropdownButtonIcon.appendChild(node);
    // });
    this.innerHTML = '';
    this.replaceWith(wcDropdownButtonIcon);
  }

}

export class WCDropdownMenu extends WCBaseComponent {

  constructor () {
    super();
  }

  render () {
    let contentNodes = [...this.childNodes];
    let clone = template.cloneNode(true);
    let wcDropdownMenu = clone.content.querySelector('.wc-dropdown-menu').cloneNode(false);
    contentNodes.forEach(node => {
      wcDropdownMenu.appendChild(node);
    });
    // this.innerHTML = '';
    this.replaceWith(wcDropdownMenu);
  }

}

export class WCDropdownMenuItem extends WCBaseComponent {

  constructor () {
    super();
  }

  render () {
    // let contentNodes = [...this.childNodes];
    let clone = template.cloneNode(true);
    let wcDropdownMenuItem = clone.content.querySelector('.wc-dropdown-menu-item').cloneNode(false);
    let wcDropdownMenuItemAnchor = clone.content.querySelector('.wc-dropdown-menu-item-anchor').cloneNode(false);
    let wcDropdownMenuItemIcon = clone.content.querySelector('.wc-dropdown-menu-item-icon').cloneNode(false);
    let wcDropdownMenuItemCaption = clone.content.querySelector('.wc-dropdown-menu-item-caption').cloneNode(false);
    let dataContext = this.getAttribute('data-context');
    let dataPreset = this.getAttribute('data-preset');
    let dataCaptionContent = this.getAttribute('data-caption-content');
    let dataContent = $$.tool.dataJSON(this.getAttribute('data-content'));
    let dataClassText = this.getAttribute('data-class-text');
    wcDropdownMenuItemAnchor.setAttribute('class', [this.getAttribute('class'), wcDropdownMenuItemAnchor.getAttribute('class')].join(' '));
    this.removeAttribute('class');
    if (dataPreset !== null && presets[dataPreset] !== undefined) {
      let preset = presets[dataPreset];
      if (preset.icon.color !== undefined && dataClassText === null) {
        wcDropdownMenuItemIcon.classList.remove('text-blue');
        wcDropdownMenuItemIcon.classList.add(preset.icon.color);
      }
      wcDropdownMenuItemIcon.classList.remove('bi-cursor');
      wcDropdownMenuItemIcon.classList.add(preset.icon.content);
      wcDropdownMenuItemCaption.textContent = dataCaptionContent === null ? preset.caption.content : dataCaptionContent;
    }
    if (dataContent !== null) {
      for (let data in dataContent) {
        wcDropdownMenuItemAnchor.dataset[data] = dataContent[data];
      }
    }
    // switch (dataContext) {
    // case 'toolbar':
    //   elementSeparator = document.createElement('br');
    //   elementSeparator.setAttribute('class', 'd-none d-md-block');
    //   break;
    // case 'resultset':
    //   element.classList.remove('btn-sm', 'm-1');
    //   element.classList.add('btn-xs', 'ms-1');
    //   break;
    // }


    // contentNodes.forEach(node => {
    //   wcDropdownMenuItem.appendChild(node);
    // });
    wcDropdownMenuItemAnchor.append(wcDropdownMenuItemIcon);
    wcDropdownMenuItemAnchor.append(document.createTextNode(' '));
    wcDropdownMenuItemAnchor.append(wcDropdownMenuItemCaption);
    wcDropdownMenuItem.append(wcDropdownMenuItemAnchor);
    this.replaceWith(wcDropdownMenuItem);


//     elementAnchor.append(elementIcon);
//     // elementAnchor.append(elementSeparator);
//     elementAnchor.append(document.createTextNode(' '));
//     elementAnchor.append(elementCaption);
//     elementItem.append(elementAnchor);
//     this.replaceWith(elementItem);
  }

}

export class WCDropdownMenuItemAnchor extends WCBaseComponent {

  constructor () {
    super();
  }

  render () {
    let contentNodes = [...this.childNodes];
    let clone = template.cloneNode(true);
    let wcDropdownMenuItemAnchor = clone.content.querySelector('.wc-dropdown-menu-item-anchor').cloneNode(false);
    // let dataContent = $$.tool.dataJSON(this.getAttribute('data-content'));
    contentNodes.forEach(node => {
      wcDropdownMenuItemAnchor.appendChild(node);
    });
    this.replaceWith(wcDropdownMenuItemAnchor);
    while (this.childNodes.length > 0) {
      wcDropdownMenuItemAnchor.append(this.childNodes[0]);
    }
//     wcDropdownMenuItemAnchor.setAttribute('class', this.getAttribute('class'));
//     wcDropdownMenuItemAnchor.setAttribute('role', 'button');
//     if (dataContent !== null) {
//       for (let data in dataContent) {
//         wcDropdownMenuItemAnchor.dataset[data] = dataContent[data];
//       }
//     }
    // this.innerHTML = '';
    this.replaceWith(wcDropdownMenuItemAnchor);
  }

}

export class WCDropdownMenuItemIcon extends WCBaseComponent {

  constructor () {
    super();
  }

  render () {
    // let contentNodes = [...this.childNodes];
    let clone = template.cloneNode(true);
    let wcDropdownMenuItemIcon = clone.content.querySelector('.wc-dropdown-menu-item-icon').cloneNode(false);
    // contentNodes.forEach(node => {
    //   wcDropdownMenuItemIcon.appendChild(node);
    // });
//     let elementIcon = document.createElement('i');
//     elementIcon.setAttribute('class', this.getAttribute('class'));
//     this.replaceWith(elementIcon);
    // this.innerHTML = '';
    this.replaceWith(wcDropdownMenuItemIcon);
  }

}

export class WCDropdownMenuItemCaption extends WCBaseComponent {

  constructor () {
    super();
  }

  render () {
    let contentNodes = [...this.childNodes];
    let clone = template.cloneNode(true);
    let wcDropdownMenuItemCaption = clone.content.querySelector('.wc-dropdown-menu-item-caption').cloneNode(false);
    contentNodes.forEach(node => {
      wcDropdownMenuItemCaption.appendChild(node);
    });
//     let elementCaption = document.createElement('span');
//     elementCaption.setAttribute('class', this.getAttribute('class'));
//     elementCaption.innerHTML = this.innerHTML;
//     this.replaceWith(elementCaption);
    // this.innerHTML = '';
    this.replaceWith(wcDropdownMenuItemCaption);
  }

}